<button
  class="scroll-to-top"
  [class.scroll-to-top--visible]="visible()"
  (click)="scrollToTop()"
  aria-label="Nach oben scrollen"
>
  <span class="material-icons">keyboard_arrow_up</span>
</button>
